import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface AccountNewCustomerModel {
    uri: string;
    unApprovedCustomers: UnApprovedCustomer[];
    properties: Properties;
}

export interface Properties {}

export interface UnApprovedCustomer {
    customerNumber?: string;
    companyName?: string;
    businessType?: string;
    status?: string;
}

export interface AccountNewCustomerParameter extends ApiParameter {}

const AccountNewCustomerUrl = "/api/v2/accountnewcustomer/unapprovedcustomers";

export async function getAccountNewCustomer(parameter: AccountNewCustomerParameter) {
    const response = await get<AccountNewCustomerModel>(AccountNewCustomerUrl, parameter);
    return response;
}
